// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"395":"02be8687d07c1d3180f9","914":"8cd39b5b3b483c6a9baf"}[chunkId] + ".css";
};